/* GetBookReviews analytics tracker (self-hosted, privacy-first).
 *
 *  - No consent:   cookieless. Nothing is written to the device; the server
 *                  counts with a daily-rotating hash. No cross-day linking.
 *  - With consent: first-party cookie gbr_cid (random id, 13 months) so
 *                  returning visitors can be recognised.
 *  - Logged in:    requests carry the login token so the admin can see a
 *                  per-account activity timeline (consent-gated for pages).
 *  - Honours Global Privacy Control, never runs for automation (webdriver),
 *    never on /admin, never for the internal qa accounts.
 *  - Zero impact on page speed: batched, keepalive fetch / sendBeacon, idle.
 *
 * Public API: window.gbrt = { track(name, props), consent(bool), status(), reset() }
 */
(function () {
  if (typeof window === 'undefined' || window.gbrt) return;
  var W = window, D = document, N = navigator;
  var ENDPOINT = '/api/e/p'; // neutral path: filter lists block "analytics"/"collect"
  var CONSENT_KEY = 'gbr_consent';
  var CID_COOKIE = 'gbr_cid';
  var OFF_KEY = 'gbr_t_off';
  var MAX_BATCH = 12, FLUSH_MS = 4000;

  function ls(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { v === null ? localStorage.removeItem(k) : localStorage.setItem(k, v); } catch (e) { /* ignore */ } }
  function cookie(name) {
    var m = D.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function setCookie(name, val, days) {
    var exp = days ? '; Max-Age=' + days * 86400 : '; Max-Age=0';
    D.cookie = name + '=' + encodeURIComponent(val) + exp + '; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
  }
  function rnd(n) {
    var a = new Uint8Array(n), s = '', c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
    (W.crypto || W.msCrypto).getRandomValues(a);
    for (var i = 0; i < n; i++) s += c[a[i] & 63];
    return s;
  }
  function gpc() { return N.globalPrivacyControl === true || N.doNotTrack === '1' ? true : false; }

  // ---- hard off switches ---------------------------------------------------
  function authUser() {
    try { var p = JSON.parse(ls('gbr-auth') || 'null'); return p && p.state ? p.state : null; } catch (e) { return null; }
  }
  function qaCheck() {
    var a = authUser();
    if (a && a.user && /^qa-jarvis/i.test(a.user.email || '')) { lsSet(OFF_KEY, '1'); return true; }
    return ls(OFF_KEY) === '1';
  }
  var off = N.webdriver === true || /^localhost$|^127\./.test(location.hostname) || qaCheck();

  // ---- consent -------------------------------------------------------------
  function consentState() {
    if (gpc()) return 'essential';
    var v = ls(CONSENT_KEY);
    if (!v) return '';
    try { var o = JSON.parse(v); if (o && o.t && Date.now() - o.t > 365 * 86400000) return ''; return o && o.v === 'all' ? 'all' : 'essential'; } catch (e) { return v === 'all' ? 'all' : 'essential'; }
  }
  function applyConsent(state) {
    if (state === 'all') {
      var id = cookie(CID_COOKIE);
      if (!/^[A-Za-z0-9_-]{16,48}$/.test(id)) id = rnd(24);
      setCookie(CID_COOKIE, id, 395);
      setCookie(CONSENT_KEY, 'all', 395);
    } else {
      setCookie(CID_COOKIE, '', 0);
      setCookie(CONSENT_KEY, '', 0);
    }
  }
  var consent = consentState();
  applyConsent(consent);

  // ---- queue + transport ---------------------------------------------------
  var q = [], timer = null;
  function payload() {
    var a = authUser();
    var body = { v: 1, c: consent === 'all' ? 1 : 0, h: location.hostname, e: q, lang: (N.language || '').slice(0, 12), scr: (screen && screen.width ? screen.width + 'x' + screen.height : '') };
    if (consent === 'all') body.cid = cookie(CID_COOKIE);
    if (N.webdriver) body.wd = 1;
    if (N.maxTouchPoints > 1 && /Mac/.test(N.platform || '')) body.tp = 1; // iPadOS pretends to be a Mac
    return { body: JSON.stringify(body), token: a && a.token ? a.token : '' };
  }
  function flush(sync) {
    if (timer) { clearTimeout(timer); timer = null; }
    if (!q.length || off) { q = []; return; }
    var p = payload(); q = [];
    var headers = { 'Content-Type': 'text/plain' };
    if (p.token) headers.Authorization = 'Bearer ' + p.token;
    try {
      if (W.fetch) {
        fetch(ENDPOINT, { method: 'POST', body: p.body, headers: headers, keepalive: true, credentials: 'same-origin', cache: 'no-store' }).catch(function () {
          if (sync && N.sendBeacon) N.sendBeacon(ENDPOINT, new Blob([p.body], { type: 'text/plain' }));
        });
      } else if (N.sendBeacon) {
        N.sendBeacon(ENDPOINT, new Blob([p.body], { type: 'text/plain' }));
      }
    } catch (e) { /* never break the page */ }
  }
  function push(ev, urgent) {
    if (off) return;
    q.push(ev);
    if (urgent || q.length >= MAX_BATCH) flush(urgent);
    else if (!timer) timer = setTimeout(function () { flush(false); }, FLUSH_MS);
  }

  // ---- page tracking --------------------------------------------------------
  var cur = null; // { path, start, active, visibleSince, maxScroll }
  function isAdmin(p) { return /^\/admin(\b|\/)/.test(p) || /^\/admin-old/.test(p) || /^\/admin2/.test(p); }
  function pathNow() { return location.pathname + (location.search || ''); }
  function scrollPct() {
    var de = D.documentElement, b = D.body;
    var h = Math.max(de.scrollHeight, b ? b.scrollHeight : 0), vh = W.innerHeight || de.clientHeight;
    if (!h || h <= vh) return 100;
    var y = W.pageYOffset || de.scrollTop || (b ? b.scrollTop : 0);
    return Math.min(100, Math.round(((y + vh) / h) * 100));
  }
  function activeMs() {
    if (!cur) return 0;
    var a = cur.active;
    if (cur.visibleSince) a += Date.now() - cur.visibleSince;
    return a;
  }
  function leave(urgent) {
    if (!cur) return;
    var d = activeMs();
    cur.maxScroll = Math.max(cur.maxScroll, scrollPct());
    push({ k: 'lv', p: cur.path, d: Math.round(d), s: cur.maxScroll }, urgent);
    cur = null;
  }
  var firstPv = true, lastRef = D.referrer || '';
  function pageview(internalFrom) {
    var p = location.pathname;
    if (isAdmin(p)) { cur = null; return; }
    var ev = { k: 'pv', p: p, q: location.search || '', t: (D.title || '').slice(0, 120), r: firstPv ? lastRef : (internalFrom ? location.origin + internalFrom : '') , ts: Date.now() };
    firstPv = false;
    cur = { path: p, start: Date.now(), active: 0, visibleSince: D.visibilityState === 'visible' ? Date.now() : 0, maxScroll: scrollPct() };
    push(ev, false);
    // library search (url parameter q) -> search event
    var m = /[?&]q=([^&]+)/.exec(location.search || '');
    if (m && /^\/library/.test(p)) {
      var term = decodeURIComponent(m[1].replace(/\+/g, ' ')).trim().slice(0, 80);
      if (term && term !== lastSearch) { lastSearch = term; push({ k: 'ev', p: p, n: 'search', pr: { q: term } }, false); }
    }
    // soft 404 (SPA renders the "not on our shelf" page)
    setTimeout(function () {
      if (cur && cur.path === p && D.querySelector('.nf') && /not found/i.test(D.title || '')) {
        push({ k: 'ev', p: p, n: 'not_found', pr: { ref: (firstPv ? '' : '') || (lastRef ? lastRef.slice(0, 120) : '') } }, false);
      }
    }, 1500);
  }
  var lastSearch = '';

  // SPA navigation: patch history + popstate (works without touching React)
  var prevPath = location.pathname;
  function onNav() {
    var p = location.pathname;
    if (p === prevPath) {
      // same page, maybe new query (library filters / search)
      var m = /[?&]q=([^&]+)/.exec(location.search || '');
      if (m && /^\/library/.test(p)) {
        var term = decodeURIComponent(m[1].replace(/\+/g, ' ')).trim().slice(0, 80);
        if (term && term !== lastSearch) { lastSearch = term; push({ k: 'ev', p: p, n: 'search', pr: { q: term } }, false); }
      }
      return;
    }
    var from = prevPath;
    prevPath = p;
    leave(false);
    if (cur === null) { /* leave already reset */ }
    pageview(from);
  }
  ['pushState', 'replaceState'].forEach(function (fn) {
    var orig = history[fn];
    if (!orig) return;
    history[fn] = function () { var r = orig.apply(this, arguments); setTimeout(onNav, 0); return r; };
  });
  W.addEventListener('popstate', function () { setTimeout(onNav, 0); });

  // visibility-aware active time + flush on hide
  D.addEventListener('visibilitychange', function () {
    if (!cur) return;
    if (D.visibilityState === 'hidden') {
      if (cur.visibleSince) { cur.active += Date.now() - cur.visibleSince; cur.visibleSince = 0; }
      cur.maxScroll = Math.max(cur.maxScroll, scrollPct());
      sendVitals();
      // send an interim "leave" so duration survives tab kills; keep page open
      push({ k: 'lv', p: cur.path, d: Math.round(cur.active), s: cur.maxScroll }, true);
      cur.active = 0;
    } else {
      cur.visibleSince = Date.now();
    }
  });
  W.addEventListener('pagehide', function () { sendVitals(); leave(true); });
  var scrollTick = false;
  W.addEventListener('scroll', function () {
    if (scrollTick || !cur) return;
    scrollTick = true;
    setTimeout(function () { scrollTick = false; if (cur) cur.maxScroll = Math.max(cur.maxScroll, scrollPct()); }, 400);
  }, { passive: true });

  // ---- outbound + amazon clicks -------------------------------------------
  D.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || !cur) return;
    var href = a.getAttribute('href') || '';
    if (!/^https?:\/\//i.test(href)) return;
    var host;
    try { host = new URL(href).hostname.replace(/^www\./, ''); } catch (err) { return; }
    if (host === location.hostname.replace(/^www\./, '')) return;
    var name = /amazon\./i.test(host) ? 'amazon_click' : 'outbound';
    push({ k: 'ev', p: cur.path, n: name, pr: { host: host.slice(0, 80) } }, true);
  }, { capture: true, passive: true });

  // ---- every button + link click -----------------------------------------------
  // Label = data-track | aria-label | visible text (max 40 chars, e-mail addresses
  // masked). Book links are folded into one label so titles do not fragment the list.
  var lastClick = '', lastClickAt = 0;
  function clean(s) { return (s || '').replace(/\s+/g, ' ').trim().replace(/[^\s@]+@[^\s@]+/g, '[mail]'); }
  function actionKey(label, to) {
    var x = (label + ' ' + to).toLowerCase();
    if (/bump/.test(x)) return 'bump';
    if (/log ?in|sign ?in|\/login/.test(x)) return 'login';
    if (/sign ?up|regist|join|\/register|create (an )?account/.test(x)) return 'signup';
    if (/add[- ]book|submit.*book|list.*book|\/add-book|new book/.test(x)) return 'submit_book';
    if (/campaign|launch/.test(x)) return 'campaign';
    if (/advertis|sponsor|spotlight|carousel/.test(x)) return 'advertise';
    return '';
  }
  D.addEventListener('click', function (e) {
    if (!cur || !e.target || !e.target.closest) return;
    var el = e.target.closest('a[href],button,[role="button"],summary,input[type="submit"],input[type="button"]');
    if (!el || el.disabled) return;
    var isA = el.tagName === 'A', to = '', href = '';
    if (isA) {
      href = el.getAttribute('href') || '';
      if (/^javascript:/i.test(href) || href === '#') return;
      try {
        var u = new URL(href, location.href);
        to = u.hostname.replace(/^www\./, '') === location.hostname.replace(/^www\./, '') ? u.pathname.replace(/\/[a-f0-9]{24}(?=\/|$)/g, '/:id') : u.hostname.replace(/^www\./, '');
      } catch (err) { to = ''; }
    }
    var label = clean(el.getAttribute('data-track') || el.getAttribute('aria-label') || (el.tagName === 'INPUT' ? el.value : el.textContent) || el.getAttribute('title') || el.id);
    if (/^\/book\/:id/.test(to) && label.length > 24) label = 'Book card';
    if (!label) label = to || el.tagName.toLowerCase();
    if (el.tagName === 'SUMMARY' && el.closest('.more')) label = 'Account menu';
    if (label.length > 40) label = label.slice(0, 40);
    var sig = label + '|' + to;
    if (sig === lastClick && Date.now() - lastClickAt < 600) return;
    lastClick = sig; lastClickAt = Date.now();
    var pr = { l: label, t: isA ? 'link' : 'button' };
    if (to) pr.to = to.slice(0, 80);
    var k = actionKey(label, to); if (k) pr.k = k;
    push({ k: 'ev', p: cur.path, n: 'click', pr: pr }, isA);
  }, { capture: true, passive: true });

  // ---- Core Web Vitals (own light implementation) ---------------------------
  var vit = { }, vitSent = false, vitPath = location.pathname;
  try {
    if ('PerformanceObserver' in W) {
      var po = function (type, cb, opts) {
        try { var o = new PerformanceObserver(function (l) { l.getEntries().forEach(cb); }); o.observe(Object.assign({ type: type, buffered: true }, opts || {})); } catch (e) { /* unsupported */ }
      };
      po('largest-contentful-paint', function (en) { vit.lcp = en.startTime; });
      po('paint', function (en) { if (en.name === 'first-contentful-paint') vit.fcp = en.startTime; });
      var clsVal = 0, sessVal = 0, sessStart = 0, sessLast = 0;
      po('layout-shift', function (en) {
        if (en.hadRecentInput) return;
        if (sessVal && en.startTime - sessLast < 1000 && en.startTime - sessStart < 5000) { sessVal += en.value; }
        else { sessVal = en.value; sessStart = en.startTime; }
        sessLast = en.startTime;
        if (sessVal > clsVal) { clsVal = sessVal; vit.cls = clsVal; }
      });
      var inter = [];
      po('event', function (en) {
        if (!en.interactionId) return;
        inter.push(en.duration);
        inter.sort(function (a, b) { return b - a; });
        if (inter.length > 50) inter.length = 50;
        vit.inp = inter[Math.min(inter.length - 1, Math.floor(inter.length / 50))];
      }, { durationThreshold: 40 });
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (nav && nav.responseStart) vit.ttfb = nav.responseStart;
    }
  } catch (e) { /* ignore */ }
  function sendVitals() {
    if (vitSent || off || isAdmin(vitPath)) return;
    var keys = Object.keys(vit);
    if (!keys.length) return;
    vitSent = true;
    var m = {}; keys.forEach(function (k) { m[k] = Math.round(vit[k] * 1000) / 1000; });
    push({ k: 'vt', p: vitPath, m: m }, false);
  }

  // ---- public api -----------------------------------------------------------
  W.gbrt = {
    track: function (name, props) { if (cur && name) push({ k: 'ev', p: cur.path, n: String(name).slice(0, 40), pr: props || {} }, false); },
    consent: function (all) {
      consent = all ? 'all' : 'essential';
      lsSet(CONSENT_KEY, JSON.stringify({ v: consent, t: Date.now() }));
      applyConsent(consent);
      if (cur) push({ k: 'ev', p: cur.path, n: all ? 'consent_all' : 'consent_essential' }, true);
      W.dispatchEvent(new CustomEvent('gbr-consent', { detail: consent }));
    },
    status: function () { return { consent: consent, decided: !!consent, gpc: gpc(), off: off }; },
    reset: function () { lsSet(CONSENT_KEY, null); consent = ''; applyConsent(''); W.dispatchEvent(new CustomEvent('gbr-consent', { detail: '' })); },
  };

  // ---- go ----------------------------------------------------------------------
  if (D.readyState === 'complete' || D.readyState === 'interactive') pageview('');
  else D.addEventListener('DOMContentLoaded', function () { pageview(''); });
  // heartbeat for long reads: every 60 s while visible, commit active time
  setInterval(function () {
    if (!cur || D.visibilityState !== 'visible') return;
    if (activeMs() >= 60000) {
      cur.active += Date.now() - cur.visibleSince; cur.visibleSince = Date.now();
      push({ k: 'lv', p: cur.path, d: Math.round(cur.active), s: Math.max(cur.maxScroll, scrollPct()) }, false);
      cur.active = 0;
    }
  }, 60000);
})();
